var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isAuthed)?_c('TopBar'):_vm._e(),_c('v-main',[_c('router-view')],1),(_vm.isAuthed)?_c('BottomNav'):_vm._e(),_c('CookieConsentBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }